import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

/**
 * Thin wrapper over Capacitor's platform detection so components can branch on
 * native-vs-web (e.g. the Home page shows a "get the app" banner only in a
 * browser) without importing Capacitor directly — and so it's trivial to stub
 * in tests.
 */
@Injectable({ providedIn: 'root' })
export class PlatformService {
  /** True inside the native iOS/Android app; false in a desktop/mobile browser. */
  isNativePlatform(): boolean {
    return Capacitor.isNativePlatform();
  }

  /** 'ios' | 'android' | 'web'. */
  platform(): string {
    return Capacitor.getPlatform();
  }
}
